import { WindAnimationMobileSVG } from "./WindAnimationMobileSVG";
export default WindAnimationMobileSVG;
